import styled from 'styled-components';
import { Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import type { FilterOption } from '../shared/types';

/* #region styles */
const AlphabeticalHeaderContainer = styled.li`
    padding: ${Spacing8} ${Spacing16};
    background-color: ${({ theme }) => theme.ColorBackgroundSecondary};

    list-style: none;
`;

/* #endregion */

let previousLetter;

export default function AlphabeticalHeader({ option }: { option: FilterOption }) {
    // assumes already sorted alphabetically

    const currentLetter = option.displayName[0].toUpperCase();
    const previousLetterUpper = previousLetter && previousLetter.toUpperCase();

    if (previousLetterUpper === currentLetter) return null;

    previousLetter = currentLetter;

    return (
        <AlphabeticalHeaderContainer>
            <Typography.Title size="S">{currentLetter}</Typography.Title>
        </AlphabeticalHeaderContainer>
    );
}
